"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeObjectCollectionSummary = void 0;
var tslib_1 = require("tslib");
var base_1 = require("./base");
var IkeObjectCollectionSummary = /** @class */ (function (_super) {
    tslib_1.__extends(IkeObjectCollectionSummary, _super);
    function IkeObjectCollectionSummary() {
        var _this = _super.call(this) || this;
        _this.className = 'CollectionSummary';
        _this.actionName = 'collection.summary';
        _this.cacheKeys['uuid'] = true;
        _this.cacheKeys['revision'] = true;
        _this.cacheKeys['collectionId'] = true;
        return _this;
    }
    IkeObjectCollectionSummary.prototype.updateCache = function (key, result, rest) {
        _super.prototype.updateCache.call(this, key, result, rest);
        this.cacheIfLatest('uuid', result, rest);
        this.cacheIfLatest('revision', result, rest);
        this.cacheIfLatest('collectionId', result, rest);
    };
    return IkeObjectCollectionSummary;
}(base_1.IkeRestObject));
exports.IkeObjectCollectionSummary = IkeObjectCollectionSummary;
//# sourceMappingURL=collection.summary.object.js.map